import React from "react"
import styled, { css } from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue, getFontSize } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"

const gridCss = css`
	.grid-container {
		margin: 0;
		display: grid;
		grid-template-columns: repeat(8, 1fr);

		.text {
			grid-column: 1 / span 8;
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		.grid-container {
			grid-template-columns: repeat(16, 1fr);

			.text {
				grid-column: 1 / span 16;
			}
		}
	}
`

const StyledUnorderedList = styled.ul`
	padding-left: ${getCssSizeValue(18)};

	li {
		${gridCss};
		list-style: none;
		margin: ${getCssSizeValue(22, BREAKPOINTS.MOBILE)};
		position: relative;

		&::before {
			content: "";
			position: absolute;
			top: ${getCssSizeValue(7, BREAKPOINTS.MOBILE)};
			left: ${getCssSizeValue(-18, BREAKPOINTS.MOBILE)};
			background: ${({ theme }) => theme.colors.richBlack};
			height: ${getCssSizeValue(6, BREAKPOINTS.MOBILE)};
			width: ${getCssSizeValue(6, BREAKPOINTS.MOBILE)};
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		li {
			margin: ${getCssSizeValue(22)};

			&::before {
				top: ${getCssSizeValue(13)};
				left: ${getCssSizeValue(-24)};
				height: ${getCssSizeValue(8)};
				width: ${getCssSizeValue(8)};
			}
		}
	}
`

const StyledOrderedList = styled.ol`
	padding-left: ${getCssSizeValue(18)};
	list-style-type: none;

	&& {
		counter-reset: section;
	}

	li {
		position: relative;
		margin: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
		${gridCss};

		&:before {
			height: 100%;
			counter-increment: section;
			content: counter(section) ".";

			position: absolute;
			left: ${getCssSizeValue(-22, BREAKPOINTS.MOBILE)};

			font-family: ${({ theme }) => theme.fontFamily.bornaFont};
			font-size: ${getFontSize(12, BREAKPOINTS.MOBILE)};
			line-height: ${getFontSize(18, BREAKPOINTS.MOBILE)};
			font-weight: ${({ theme }) => theme.fontWeight.regular};
			@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
				font-size: ${getFontSize(14, BREAKPOINTS.TABLET)};
				line-height: normal;
			}
			@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
				font-size: ${getFontSize(18.5, BREAKPOINTS.DESKTOP)};
				line-height: ${getFontSize(34, BREAKPOINTS.DESKTOP)};
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		li {
			margin: ${getCssSizeValue(22)};
			${gridCss};

			&:before {
				left: ${getCssSizeValue(-24)};
				font-size: ${getFontSize(12, BREAKPOINTS.MOBILE)};
				line-height: ${getFontSize(18, BREAKPOINTS.MOBILE)};
				font-weight: ${({ theme }) => theme.fontWeight.regular};
				@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
					font-size: ${getFontSize(14, BREAKPOINTS.TABLET)};
					line-height: normal;
				}
				@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
					font-size: ${getFontSize(18.5, BREAKPOINTS.DESKTOP)};
					line-height: ${getFontSize(34, BREAKPOINTS.DESKTOP)};
				}
			}
		}
	}
`

const List = ({ data, children }) => {
	const listStyle = data.style
	return (
		<GridContainer className="indent-desktop-5">
			{listStyle === "bulleted" ? (
				<StyledUnorderedList className="col-mobile-8 col-desktop-6">{children}</StyledUnorderedList>
			) : (
				<StyledOrderedList className="col-mobile-8 col-desktop-6">{children}</StyledOrderedList>
			)}
		</GridContainer>
	)
}

export default List
